/* eslint-disable no-bitwise */
import Vue from 'vue';

import { OperationFlags } from '#components/dms/common/operationFlagsConstants';

export const OperationsMixin = Vue.extend({
	computed: {
		operations(): OperationFlags {
			return OperationFlags.DEFAULT;
		},
		canProcess(): boolean {
			return !!(this.operations & OperationFlags.PROCESS);
		},
		canEdit(): boolean {
			return !!(this.operations & OperationFlags.EDIT);
		},
		canView(): boolean {
			return !!(this.operations & OperationFlags.VIEW);
		},
		canDelete(): boolean {
			return !!(this.operations & OperationFlags.DELETE);
		},
		canCreate(): boolean {
			return !!(this.operations & OperationFlags.CREATE);
		},
		canExport(): boolean {
			return !!(this.operations & OperationFlags.EXPORT);
		},
		canCancel(): boolean {
			return !!(this.operations & OperationFlags.CANCEL);
		},
	},
});
